export default __webpack_public_path__ + "static/media/snow.4454bd79.svg";